export const GET_REPAIR_VALUE_REQUEST = "GET_REPAIR_VALUE_REQUEST";
export const GET_REPAIR_VALUE_SUCCESS = "GET_REPAIR_VALUE_SUCCESS";
export const GET_REPAIR_VALUE_FAILURE = "GET_REPAIR_VALUE_FAILURE";

export const GET_DELETE_REPAIR_VALUE_REQUEST = "GET_DELETE_REPAIR_VALUE_REQUEST";
export const GET_DELETE_REPAIR_VALUE_SUCCESS = "GET_DELETE_REPAIR_VALUE_SUCCESS";
export const GET_DELETE_REPAIR_VALUE_FAILURE = "GET_DELETE_REPAIR_VALUE_FAILURE";


export const CREATE_REPAIR_VALUE_REQUEST = "CREATE_REPAIR_VALUE_REQUEST";
export const CREATE_REPAIR_VALUE_SUCCESS = "CREATE_REPAIR_VALUE_SUCCESS";
export const CREATE_REPAIR_VALUE_FAILURE = "CREATE_REPAIR_VALUE_FAILURE";

export const EDIT_PREPAIR_REQUEST = "EDIT_PREPAIR_REQUEST";
export const EDIT_PREPAIR_SUCCESS = "EDIT_PREPAIR_SUCCESS";
export const EDIT_PREPAIR_FAILURE = "EDIT_PREPAIR_FAILURE";

export const UPLOAD_PREPAIR_REQUEST = "UPLOAD_PREPAIR_REQUEST";
export const UPLOAD_PREPAIR_SUCCESS = "UPLOAD_PREPAIR_SUCCESS";
export const UPLOAD_PREPAIR_FAILURE = "UPLOAD_PREPAIR_FAILURE";
